<div id="ficha-op-abierta-audiovisuales" class="h-100">
  <!-- #region 1 oportunidad -->
  @if (totalOportunidades === 1) {
    <div id="fichas-oportunidades-1" class="border-radius-2 border-1 border-primary-300 shadow-4 mb-1">
      <div class="row p-2 p-lg-3 align-content-between">
        <div class="col-12 col-lg-5">
          <div class="d-flex h-100">
            @if (plataformaId === 'CREATIVE') {
              <a routerLink="/audiovisuales/{{oportunidad.slug}}"
                target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto: {{oportunidad.nombre}}"
                class="contenedor-img w-100 contenedor-una-oportunidad" [ngStyle]="{'background-image': 'url(' + oportunidad.portadaOportunidadesUrl + ')'}">
                @if (showTagSobrefinanciado) {
                  <div
                    class="tag-activo-invertir-position">
                    <app-tag-overfunding [plataforma]="'CREATIVE'"></app-tag-overfunding>
                  </div>
                }
              </a>
            }
            @if (plataformaId !== 'CREATIVE') {
              <a
                href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto: {{oportunidad.nombre}}"
                class="contenedor-img w-100  contenedor-una-oportunidad" [ngStyle]="{'background-image': 'url(' + oportunidad.portadaOportunidadesUrl + ')'}">
                @if (showTagSobrefinanciado) {
                  <div
                    class="tag-activo-invertir-position">
                    <app-tag-overfunding [plataforma]="'CREATIVE'"></app-tag-overfunding>
                  </div>
                }
              </a>
            }
          </div>
        </div>
        <div class="col-12 col-lg-7">
          <div class="row h-100">
            <div class="col-12 mb-2">
              <div class="row align-items-center mt-2 mt-lg-0">
                @if (oportunidad.tipoEstadoRondaId === 'en-financiacion' || oportunidad.tipoEstadoRondaId === 'proximamente') {
                  <div
                    class="col-12 col-sm-7 mt-2 mt-lg-0 d-flex justify-content-between justify-content-sm-start">
                    <div class="d-flex align-items-center me-3">
                      <app-tags-audiovisual [tagId]="'prestamo'"></app-tags-audiovisual>
                    </div>
                    @if (oportunidad.tipoEstadoRondaId === 'en-financiacion') {
                      <div>
                        <app-dias-restantes [plataforma]="'creative'"
                        [diasRestantes]="oportunidad.diasRestantes"></app-dias-restantes>
                      </div>
                    }
                  </div>
                }
                <div class="col-12 d-flex justify-content-end align-items-center mt-2 mt-lg-0"
                  [ngClass]="{'col-sm-5': oportunidad.tipoEstadoRondaId === 'en-financiacion' || oportunidad.tipoEstadoRondaId === 'proximamente'}">
                  <app-tag-estado-ronda-creative
                  [tipoEstadoRonda]="{ nombre: oportunidad.tipoEstadoRonda, tipoEstadoRondaId: oportunidad.tipoEstadoRondaId}"></app-tag-estado-ronda-creative>
                </div>
              </div>
              <div class="row mt-3">
                <h2 class="h2-semibold primary-900 mb-2" matTooltip={{oportunidad.nombre}}
                  matTooltipPosition="below">
                {{oportunidad.nombre | maxCharacters:30}}</h2>
                <p class="p2-medium neutral-900 mb-1">
                  {{oportunidad.descripcionMini | maxCharacters:167}}
                </p>
              </div>
              @if (oportunidad.tipoEstadoRondaId === 'en-financiacion') {
                <div
                  class="d-flex align-items-center justify-content-between mb-1">
                  <div class="info-container">
                    <p class="p3-medium mb-1">Tipo<br class="salto-linea">
                    interés:</p>
                    <p class="p2-bold neutral-900">{{oportunidad.tipoInteres}}%
                    </p>
                  </div>
                  <div class="info-container">
                    <p class="p3-medium mb-1">Pago <br class="salto-linea">intereses:</p>
                    <p class="p2-bold neutral-900">{{oportunidad.tipoPagoIntereses}}</p>
                  </div>
                  <div class="info-container">
                    <p class="p3-medium mb-1">Plazo del<br class="salto-linea">
                    préstamo:</p>
                    <p class="p2-bold neutral-900">{{oportunidad.plazoMeses}} meses</p>
                  </div>
                </div>
              }
            </div>
            <div class="col-12 align-self-end">
              @if (oportunidad.tipoEstadoRondaId === 'en-financiacion') {
                <div class="row align-items-end  mb-2">
                  <div class="col-12 col-lg-7">
                    <p class="p2-cifras primary-900 mb-1">
                      {{oportunidad.capitalSolicitado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                    </p>
                    <app-progress-bar
                    [porcientoCompletado]="oportunidad.porcentajeFinanciado"></app-progress-bar>
                  </div>
                  <div class="d-none d-lg-block col-5 ps-4 text-end">
                    @if (plataformaId === 'CREATIVE') {
                      <a
                        routerLink="/audiovisuales/{{oportunidad.slug}}"
                        target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                        class="btn btn-primary w-100">
                        Ver proyecto
                      </a>
                    }
                    @if (plataformaId !== 'CREATIVE') {
                      <a
                        href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                        target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                        class="btn btn-primary w-100">
                        Ver proyecto
                      </a>
                    }
                  </div>
                  <div class="col-12 mt-2 col-lg-7">
                    <span class="p2-regular neutral-900">
                      {{oportunidad.capitalRecaudado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                      conseguidos | {{oportunidad.porcentajeFinanciado}}%
                    </span>
                  </div>
                  <div class="col-12 col-lg-5 ps-lg-4">
                    <div class="d-block d-lg-none mt-3 mb-2 pb-1">
                      @if (plataformaId === 'CREATIVE') {
                        <a
                          routerLink="/audiovisuales/{{oportunidad.slug}}"
                          target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                          class="btn btn-primary w-100">
                          Ver proyecto
                        </a>
                      }
                      @if (plataformaId !== 'CREATIVE') {
                        <a
                          href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                          target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                          class="btn btn-primary w-100">
                          Ver proyecto
                        </a>
                      }
                    </div>
                    <p class="p3-regular neutral-900 mb-0">
                      <strong class="p3-semibold">{{oportunidad.inversoresInteresados}}</strong><span> inversores
                    interesados</span>
                  </p>
                </div>
              </div>
            }
            @if (oportunidad.tipoEstadoRondaId === 'proximamente') {
              <div class="row align-items-end">
                <div class="col-12 col-xl-8">
                  <div class="d-flex align-items-center justify-content-between mb-3 mb-xl-1">
                    <div class="info-container">
                      <p class="p3-medium mb-1">Tipo<br class="salto-linea">
                      interés:</p>
                      <p class="p2-bold neutral-900">{{oportunidad.tipoInteres}}%
                      </p>
                    </div>
                    <div class="info-container">
                      <p class="p3-medium mb-1">Pago <br class="salto-linea">intereses:
                      </p>
                      <p class="p2-bold neutral-900">
                      {{oportunidad.tipoPagoIntereses}}</p>
                    </div>
                    <div class="info-container">
                      <p class="p3-medium mb-1">Plazo del<br class="salto-linea">
                      préstamo:</p>
                      <p class="p2-bold neutral-900">{{oportunidad.plazoMeses}}
                        meses
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-7">
                  <p class="p2-cifras primary-900">
                    {{oportunidad.capitalSolicitado |
                  euroCurrency:'EUR':'symbol':'1.0-0'}}</p>
                  <a href="mailto:comunicacion@segofinance.com"
                    title="Contactar para obtener más información" class="link2-bold primary-900">
                    <div class="d-flex align-items-center mb-4 mb-xl-0">
                      <span class="secondary-creative-500 material-symbols-outlined me-1 me-lg-2">mark_email_read</span>
                      Más información
                    </div>
                  </a>
                </div>
                <div class="col-12 col-xl-5 ps-xl-4 text-end">
                  @if (plataformaId === 'CREATIVE') {
                    <a
                      routerLink="/audiovisuales/{{oportunidad.slug}}"
                      target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                      class="btn btn-primary w-100"> Ver proyecto
                    </a>
                  }
                  @if (plataformaId !== 'CREATIVE') {
                    <a
                      href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                      target="{{ref == 'home' ? '_blank' : '_self'}}" title="Ver proyecto"
                      class="btn btn-primary w-100"> Ver proyecto
                    </a>
                  }
                  <p class="p3-regular neutral-900 text-start mt-2 mb-0 d-none d-xl-block">
                    <strong class="p3-semibold">{{oportunidad.inversoresInteresados}}</strong> inversores
                    interesados
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- #endregion-->

<!-- #region +2 oportunidades -->
@if (totalOportunidades > 1) {
  <div id="fichas-oportunidades-swiper" class="border-radius-2 shadow-4 border-1 border-primary-300 d-flex flex-column align-items-stretch h-100">
    <div class="row">
      <div class="col-12">
        @if (plataformaId === 'CREATIVE') {
          <a routerLink="/audiovisuales/{{oportunidad.slug}}"
            title="Ver proyecto: {{oportunidad.nombre}}">
            <div class="contenedor-img" [ngStyle]="{'background-image': 'url(' + oportunidad.portadaOportunidadesUrl + ')'}">
              @if (showTagSobrefinanciado) {
                <div
                  class="tag-activo-invertir-position">
                  <app-tag-overfunding [plataforma]="'CREATIVE'"></app-tag-overfunding>
                </div>
              }
            </div>
          </a>
        }
        @if (plataformaId !== 'CREATIVE') {
          <a
            href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
            title="Ver proyecto: {{oportunidad.nombre}}">
            <div class="contenedor-img" [ngStyle]="{'background-image': 'url(' + oportunidad.portadaOportunidadesUrl + ')'}">
              @if (showTagSobrefinanciado) {
                <div
                  class="tag-activo-invertir-position">
                  <app-tag-overfunding [plataforma]="'CREATIVE'"></app-tag-overfunding>
                </div>
              }
            </div>
          </a>
        }
      </div>
    </div>
    <div class="row flex-grow-1 p-3">
      <div class="col-12">
        <!-- #region Bloque de etiquetas -->
        <div class="row align-items-center mb-2">
          @if (oportunidad.tipoEstadoRondaId === 'en-financiacion' || oportunidad.tipoEstadoRondaId === 'proximamente') {
            <div
              class="col-12 col-lg-8 col-lg-12 col-xl-8 d-flex justify-content-between justify-content-xl-start align-items-center">
              <div class="d-flex align-items-center me-3">
                <app-tags-audiovisual [tagId]="'prestamo'"></app-tags-audiovisual>
              </div>
              @if (oportunidad.tipoEstadoRondaId === 'en-financiacion') {
                <div
                  class="d-flex align-items-center">
                  <app-dias-restantes [plataforma]="'creative'"
                    [diasRestantes]="oportunidad.diasRestantes"
                  [isPlazoAmpliado]="oportunidad.isPlazoAmpliado"></app-dias-restantes>
                </div>
              }
            </div>
          }
          <div class="col-12 mt-3 mt-xl-0 text-end"
            [ngClass]="{'col-lg-4 col-lg-12 col-xl-4': oportunidad.tipoEstadoRondaId === 'en-financiacion' || oportunidad.tipoEstadoRondaId === 'proximamente'}">
            <app-tag-estado-ronda-creative
            [tipoEstadoRonda]="{ nombre: oportunidad.tipoEstadoRonda, tipoEstadoRondaId: oportunidad.tipoEstadoRondaId}"></app-tag-estado-ronda-creative>
          </div>
        </div>
        <!-- #endregion -->
        <!-- #region Bloque titulo mas descripcion -->
        <div class="row mb-3">
          <div class="col-12">
            <h2 class="h2-semibold primary-900 mb-1" matTooltip={{oportunidad.nombre}} matTooltipPosition="below">
            {{oportunidad.nombre | maxCharacters:24}}</h2>
            <p class="p2-medium neutral-900" matTooltip={{oportunidad.descripcionMini}}
              matTooltipPosition="below"> 
            {{oportunidad.descripcionMini | maxCharacters:158 }}</p>
          </div>
        </div>
        <!-- #endregion -->
        <!-- #region Bloque condiciones -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="info-container">
            <p class="p3-medium mb-1">Tipo<br> interés:</p>
            <p class="p2-bold neutral-900">{{oportunidad.tipoInteres}}%
            </p>
          </div>
          <div class="info-container">
            <p class="p3-medium mb-1">Pago <br>intereses:</p>
            <p class="p2-bold neutral-900">{{oportunidad.tipoPagoIntereses}}</p>
          </div>
          <div class="info-container">
            <p class="p3-medium mb-1">Plazo del<br> préstamo:
            </p>
            <p class="p2-bold neutral-900">{{oportunidad.plazoMeses}} meses</p>
          </div>
        </div>
        <!-- #endregion -->
      </div>
      <div class="col-12 mt-auto">
        @if (oportunidad.tipoEstadoRondaId === 'en-financiacion') {
          <div class="row">
            <div class="col-12 col-xl-7">
              <p class="p2-cifras primary-900">
                {{oportunidad.capitalSolicitado |
              euroCurrency:'EUR':'symbol':'1.0-0'}}</p>
              <app-progress-bar
              [porcientoCompletado]="oportunidad.porcentajeFinanciado"></app-progress-bar>
            </div>
            <div class="d-none d-xl-block col-5 ps-4 text-end">
              @if (plataformaId === 'CREATIVE') {
                <a routerLink="/audiovisuales/{{oportunidad.slug}}"
                  title="Ver proyecto" class="btn btn-primary w-100">
                  Ver proyecto
                </a>
              }
              @if (plataformaId !== 'CREATIVE') {
                <a
                  href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}" title="Ver proyecto"
                  class="btn btn-primary w-100">
                  Ver proyecto
                </a>
              }
            </div>
            <div class="col-12 mt-2 col-xl-7">
              <p class="p2-regular neutral-900">
                {{oportunidad.capitalRecaudado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                conseguidos | {{oportunidad.porcentajeFinanciado}}%
              </p>
            </div>
            <div class="col-12 col-xl-5 ps-xl-4">
              <div class="d-block d-xl-none mt-3 mb-2 pb-1">
                @if (plataformaId === 'CREATIVE') {
                  <a
                    routerLink="/audiovisuales/{{oportunidad.slug}}" title="Ver proyecto"
                    class="btn btn-primary w-100">
                    Ver proyecto
                  </a>
                }
                @if (plataformaId !== 'CREATIVE') {
                  <a
                    href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                    title="Ver proyecto" class="btn btn-primary w-100">
                    Ver proyecto
                  </a>
                }
              </div>
              <p class="p3-regular neutral-900 mb-0 mt-2">
                <strong class="p2-semibold">{{oportunidad.inversoresInteresados}}</strong><span> inversores
              interesados</span>
            </p>
          </div>
        </div>
      }
      @if (oportunidad.tipoEstadoRondaId === 'proximamente') {
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 mb-1 d-flex justify-content-between">
                <p class="p2-cifras primary-900">
                  {{oportunidad.capitalSolicitado |
                euroCurrency:'EUR':'symbol':'1.0-0'}}</p>
                @if (plataformaId === 'CREATIVE') {
                  <a
                    routerLink="/audiovisuales/{{oportunidad.slug}}" title="Ver proyecto"
                    class="btn btn-primary px-5 d-none d-xl-block">
                    Ver proyecto
                  </a>
                }
                @if (plataformaId !== 'CREATIVE') {
                  <a
                    href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}"
                    title="Ver proyecto" class="btn btn-primary px-5 d-none d-xl-block">
                    Ver proyecto
                  </a>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-8 mt-2 mt-xl-0">
            <a href="mailto:comunicacion@segofinance.com"
              title="Contactar para obtener más información" class="link2-bold primary-900">
              <div class="d-flex align-items-center mb-4 mb-xl-0">
                <span class="secondary-creative-500 material-symbols-outlined me-1 me-lg-2">mark_email_read</span>
                Más información
              </div>
            </a>
          </div>
          <div class="col-12 col-xl-4 d-block d-xl-none">
            @if (plataformaId === 'CREATIVE') {
              <a routerLink="/audiovisuales/{{oportunidad.slug}}"
                title="Ver proyecto" class="btn btn-primary w-100">
                Ver proyecto
              </a>
            }
            @if (plataformaId !== 'CREATIVE') {
              <a
                href="{{creativeDomainUrl}}/audiovisuales/{{oportunidad.slug}}" title="Ver proyecto"
                class="btn btn-primary w-100">
                Ver proyecto
              </a>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
<!--#endregion-->
</div>